export default __webpack_public_path__ + "static/media/backend.a4878a8f.png";